import axios from 'axios'
import store from '@/store'

export default {

  async saveInvoiceImage(image) {
    let bodyFormData = new FormData()
    bodyFormData.append('file', image)
    try {
      let result = await axios.post(
        store.getters.getOpaApi + '/files/company/' + store.state.company.companyId + '/path/membership_invoice?complement_path=/' + store.state.user.id,
        bodyFormData,
        { headers: {'Content-Type': 'form-data' }}
      )
      if (result.data) {
        return {error: false, data:result.data, msg: 'Nota cadastrada com sucesso'}
      } else {
        return {error: true, msg: 'Erro ao realizar upload'}
      }
    } catch (e) {
      let error = {e}
      return {error: true, msg: error.e.msg}
    }
  }

}